import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Version from "version";
import { Grid } from "@material-ui/core";
import { LargeButton, SmallButton } from '../controls/components/Buttons';
import { TextField } from '../controls/TextField';
import ReactLoading from 'react-loading';
import Icon from "../components/Selfcare/Common/Icon";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import theme from 'theme';
import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);



class ActivateSimcard extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ActivateSimcard", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            vmArg:
            {
                SubscriptionNo: props.SubscriptionNo,
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            Password: '',
            SimNo: '',
            OrderSent: false,
            OrderError: '',
            buzy: false,
            ErrorField: '',
            ErrorText: '',
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OrderSent && !this.state.OrderSent) {
            MySwal.fire({
                title: this.props.t('selfcare:message.currently-activating-sim'),
                html: this.props.t('selfcare:message.few-minutes-otherwise-restart-phone'),
                icon: 'success',
                confirmButtonColor: theme.palette.primary.main,
            }).then((result) => {
                if (this.props.handleRefresh)
                    this.props.handleRefresh();
                if (this.props.handleClose)
                    this.props.handleClose();
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.order-failed'),
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: theme.palette.primary.main,
            });
            this.setState({ buzy: false });
        }
        if (nextState.Message && !this.state.Message) {
            setTimeout(
                function () {
                    MySwal.fire({
                        title: nextState.Message.MessageTitle,
                        html: nextState.Message.MessageText,
                        icon: nextState.Message.MessageType,
                        confirmButtonText: nextState.Message.ConfirmButtonText,
                        confirmButtonColor: theme.palette.primary.main,
                    }).then((result) => {
                        switch (nextState.Message.Action) {
                            case 'close':
                                if (this.props.handleRefresh)
                                    this.props.handleRefresh();
                                if (this.props.handleClose)
                                    this.props.handleClose();
                                break;
                            case 'none':
                                break;
                            case 'reload':
                                window.location.reload();
                                break;
                            case 'redirect':
                                window.location.replace(nextState.Message.ActionParam);
                                break;
                            default:
                                break;
                        }
                    });
                }.bind(this),
                10
            );
        }
        if (nextState.ErrorField && !this.state.ErrorField) {
            this.setState({ buzy: false });
            this.setFocus(nextState.ErrorField);
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    setFocus = fieldName => {
        switch (fieldName) {
            case "Password":
                if (this.Password) {
                    setTimeout(() => {
                        this.Password.focus();
                    }, 10);
                }
                break;
            case "SimNo":
                if (this.SimNo) {
                    setTimeout(() => {
                        this.SimNo.focus();
                    }, 10);
                }
                break;
        }
    }

    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }


    render() {
        const classes = this.props;
        const { t } = this.props;
        return (
            <div style={{ height: '100vh' }}>
                <div style={{ backgroundColor: theme.palette.primary.main, color: theme.palette.common.white, padding: '20px' }}>
                    <Grid container justify="center">
                        <Grid item xs={12} sm={10}>
                            <Icon name="simcard" size={48} color={theme.palette.common.white} />
                            <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                {t('selfcare:item.activate-new-sim')}
                            </div>
                            <div style={{ fontSize: '14px' }}>
                                {t('selfcare:item.ordered-sim-sent')}
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <form onSubmit={(e) => { e.preventDefault(); this.setState({ buzy: true, ErrorField: '' }); this.dispatchState({ PerformChange: { Password: this.state.Password, SimNo: this.state.SimNo } }); }}>
                    <Grid container justify="center">
                        <Grid item xs={12} sm={10}>
                            {this.state.UnblockFirst && <div style={{ paddingTop: '20px', paddingLeft: '10px', paddingRight: '10px' }}>
                                <p style={{ fontSize: '14px' }}>{t('selfcare:info.to-activate-sim-open-subscription')}</p>
                                <div style={{ maxWidth: '320px' }}>
                                    <TextField fullWidth
                                        autoFocus
                                        noPadding
                                        disabled={this.state.buzy}
                                        localState={this.state}
                                        setLocalState={this.setState.bind(this)}
                                        name="Password"
                                        label={t('selfcare:label.password-submitted-at-block')}
                                        id="Password"
                                        maxLength={30}
                                        inputRef={(el) => { this.Password = el }}
                                        margin="normal"
                                    />
                                </div>
                            </div>}
                            {this.state.CanActivate && <div style={{ paddingTop: '20px', paddingLeft: '10px', paddingRight: '10px' }}>
                                <div style={{ maxWidth: '320px' }}>
                                    <TextField fullWidth
                                        noPadding
                                        autoFocus
                                        disabled={this.state.buzy}
                                        localState={this.state}
                                        setLocalState={this.setState.bind(this)}
                                        label={t('selfcare:label.final-6-digits-sim')}
                                        id="SimNo"
                                        name="SimNo"
                                        type="tel"
                                        maxLength={30}
                                        labelWidth="340px"
                                        helperText={this.state.ErrorField === 'SimNo' && this.state.ErrorMessage}
                                        inputRef={(el) => { this.SimNo = el }}
                                    />
                                </div>
                                <Grid container direction="column" justify="space-around" alignItems="center">
                                    <div style={{ paddingTop: '20px' }}>
                                        <LargeButton type="submit" disabled={this.state.buzy} style={{ marginRight: '10px' }}>{t('selfcare:button.activate')}</LargeButton>
                                        <LargeButton id='cancel' variant="text" color="secondary" disabled={this.state.buzy} onClick={() => { this.props.handleClose(); }}>{t('selfcare:button.cancel')}</LargeButton>
                                    </div>
                                </Grid>
                            </div>}
                            {!this.state.CanActivate &&
                                <Grid container direction="column" justify="space-around" alignItems="center">
                                    <div>
                                        {t('selfcare:error.no-order-sim-found')}<br />
                                        <LargeButton id='back' disabled={this.state.buzy} onClick={() => { this.props.handleClose(); }}><Icon name="back" size={32} color="#FFFFFF" />{t('selfcare:button.back')}</LargeButton>
                                    </div>
                                </Grid>
                            }
                            {this.state.buzy &&
                                <Grid container direction="column" justify="space-around" alignItems="center">
                                    <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={'50px'} width={'50px'} />
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </form>
            </div>
        );
    }
}
ActivateSimcard.propTypes = {
};

export default compose(
    withTranslation(),
)(withAITracking(reactPlugin, ActivateSimcard));

